import { getChatMessagesSeeker } from '../../../apiclient/resources/seeker';
import { Upload } from '../../../apiclient/resources/lead';
import { UploadTrackSeeker } from '../../../services/gtmServices';

import * as actions from './actions';
import * as utils from './utils';

const fetchMessages = (contactId, leadName, scrollDownHandle, t) => dispatch => {
  dispatch(actions.fetchMessagesSeekerReset({}));
  dispatch(actions.fetchMessagesSeeker(contactId));
  getChatMessagesSeeker(contactId).then(({ error, data }) => {
    if (!error) {
      utils.setGroupMessages(data, t, leadName)(groupMessages => {
        dispatch(actions.fetchMessagesSeekerSucceeded({ messages: [...data], groupMessages, leadName }));
        setTimeout(() => scrollDownHandle(), 1);
      });
    } else {
      dispatch(actions.fetchMessagesSeekerFailed(error));
    }
  });
};

const fetchAddFile = form => dispatch => {
  dispatch(actions.addFile());
  Upload(form).then(({ error, data }) => {
    if (!error) {
      dispatch(actions.addFileSuceeded(data));
      UploadTrackSeeker('upload_file');
    } else {
      dispatch(actions.errorUpload([]));
    }
  });
};

const fetchRevertError = data => dispatch => {
  dispatch(actions.revertError());
};

const displaySnackbar = () => dispatch => {
  dispatch(
    actions.showSnackBar({
      message: 'error',
      show: true,
      isError: true
    })
  );
};

const NotdisplaySnackbar = () => dispatch => {
  dispatch(
    actions.showSnackBar({
      message: 'error',
      show: false,
      isError: true
    })
  );
};

const fetchResetFileState = () => dispatch => {
  dispatch(actions.resetFileState({}));
};

const fetchMessagesReset = () => dispatch => {
  dispatch(actions.fetchMessagesSeekerReset({}));
};

const fetchRemoveFile = data => dispatch => {
  dispatch(actions.removeFile(data));
};

const fetchShowModal = () => dispatch => {
  dispatch(actions.showModal({}));
};

export const { addMessageSeeker, addFile, addMessageSeekerSucceded } = actions;

export {
  fetchMessages,
  fetchAddFile,
  fetchRemoveFile,
  fetchMessagesReset,
  displaySnackbar,
  fetchRevertError,
  fetchResetFileState,
  fetchShowModal
};
